import { z } from 'zod';
import { FlowTagNameCollectionSchema } from '../flow/tags.js';
/**
 * Path parameters the endpoints addressing one human task accept.
 *
 * The id is not validated as a uuid, which these endpoints predate; a malformed one fails the
 * lookup instead.
 */
export const HumanTaskIdParamsSchema = z.object({
    humanTaskId: z.string().describe('The human task.'),
});
/** Path parameters `GET /human-tasks/external/{humanTaskExternalId}` accepts. */
export const HumanTaskExternalIdParamsSchema = z.object({
    humanTaskExternalId: z.string().describe('The id the system outside flow knows the task by.'),
});
/** Path parameters the endpoints addressing one step of one subtask accept. */
export const HumanTaskSubtaskStepParamsSchema = HumanTaskIdParamsSchema.extend({
    subtaskId: z.string().describe('The subtask within the task.'),
    stepId: z.string().describe('The step within the subtask.'),
});
/** Body `PATCH /human-tasks/{humanTaskId}/tags` accepts: the complete set of tags to leave in place. */
export const HumanTaskTagsUpdateBodySchema = z.object({
    tags: FlowTagNameCollectionSchema.describe('Tags the task should carry afterwards.'),
});
/**
 * Body `POST /human-tasks/synthetic` accepts, which seeds a task chain for smoke tests. Served only
 * outside production.
 */
export const HumanTaskSyntheticSeedBodySchema = z.object({
    organizationId: z.uuid().describe('Organization to seed the chain in.'),
    name: z.string().describe('Name of the flow the chain hangs from.'),
    config: z.record(z.string(), z.unknown()).describe('Task configuration to seed.'),
});
/** Path parameters `DELETE /human-tasks/synthetic/{flowId}` accepts. */
export const HumanTaskSyntheticFlowIdParamsSchema = z.object({
    flowId: z.uuid().describe('The seeded flow whose chain is removed.'),
});
//# sourceMappingURL=params.js.map